// extracted by mini-css-extract-plugin
export default {"list":"ShowDimensionsDeliveryPoint_list__uC8Oo","wrapper":"ShowDimensionsDeliveryPoint_wrapper__ohNNt"};